import RequestConfig from '../../RequestConfig'

export class AccessGroupService {
    private static baseUrl: string = `${process.env.REACT_APP_API_URL}/permission/access-group`;

    private static token = localStorage.getItem('token')

    static async getAccessGroup(
        options?: any
    ): Promise<any> {
        try {
            const request = await RequestConfig.post(
                `${this.baseUrl}/get-group`,
                options,
                {
                    headers: {
                        genie_access_token: `Bearer ${this.token}`
                    }
                }
            );
            const response = request.data;
            return response;
        } catch (error: any) {
            return error?.response;
        }
    }

    static async createAccessGroup(
        accessGroupDetails: any
    ): Promise<any> {
        try {
            const request = await RequestConfig.post(
                `${this.baseUrl}/create-group`,
                accessGroupDetails,
                {
                    headers: {
                        genie_access_token: `Bearer ${this.token}`
                    }
                }
            );
            const response = request.data;
            return response;
        } catch (error: any) {
            return error?.response;
        }
    }

    static async updateAccessGroup(
        accessGroupDetails: any
    ): Promise<any> {
        try {
            const request = await RequestConfig.put(
                `${this.baseUrl}/update-group`,
                accessGroupDetails,
                {
                    headers: {
                        genie_access_token: `Bearer ${this.token}`
                    }
                }
            );
            const response = request.data;
            return response;
        } catch (error: any) {
            return error?.response;
        }
    }

    static async deleteAccessGroup(
        appAccessGroupIds: string[]
    ): Promise<any> {
        try {
            const request = await RequestConfig.delete(`${this.baseUrl}/delete-group`, {
                data: { appAccessGroupIds },
                headers: {
                    genie_access_token: `Bearer ${this.token}`
                }
            });
            const response = request.data;
            return response;
        } catch (error: any) {
            return error?.response;
        }
    }
}